import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const DashboardNavDropdown = ({ user, onLogout, isMobile = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  if (isMobile) {
    return (
      <div className="space-y-1">
        <Link to="/inbox" className="block px-4 py-2 text-white hover:bg-white/10 transition-colors">
          📨 Messages
        </Link>
        <Link to="/jobs/manage" className="block px-4 py-2 text-white hover:bg-white/10 transition-colors">
          💼 My Jobs
        </Link>
        <Link to="/profile" className="block px-4 py-2 text-white hover:bg-white/10 transition-colors">
          👤 Profile
        </Link>
        {user?.userType === 'provider' && (
          <Link to="/provider-dashboard" className="block px-4 py-2 text-white hover:bg-white/10 transition-colors">
            🏪 Provider Dashboard
          </Link>
        )}
        {(user?.userType === 'admin' || user?.userType === 'supervisor') && (
          <Link to={user?.userType === 'admin' ? '/admin' : '/supervisor-dashboard'} className="block px-4 py-2 text-white hover:bg-white/10 transition-colors">
            {user?.userType === 'admin' ? '⚙️ Admin Panel' : '⚙️ Supervisor Panel'}
          </Link>
        )}
        <button 
          onClick={onLogout}
          className="block w-full text-left px-4 py-2 text-red-300 hover:bg-red-500/30 transition-colors"
        >
          🚪 Logout
        </button>
      </div>
    );
  }

  return (
    <div className="relative" ref={dropdownRef}>
      <Button 
        variant="outline" 
        className="border-white/50 text-white bg-white/10"
        onClick={toggleDropdown}
      >
        Menu
        <svg 
          className={`w-4 h-4 ml-1 transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </Button>
      
      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-56 bg-slate-800/95 backdrop-blur-lg border border-white/20 rounded-lg shadow-lg z-50">
          <div className="py-2">
            {/* Navigation Section */}
            <div className="px-4 py-2 text-xs font-medium text-white/60 uppercase tracking-wider">
              Navigation
            </div>
            <Link 
              to="/inbox" 
              className="block px-4 py-2 text-white hover:bg-white/10 transition-colors"
              onClick={handleLinkClick}
            >
              📨 Messages
            </Link>
            <Link 
              to="/jobs/manage" 
              className="block px-4 py-2 text-white hover:bg-white/10 transition-colors"
              onClick={handleLinkClick}
            >
              💼 My Jobs
            </Link>
            <Link 
              to="/profile" 
              className="block px-4 py-2 text-white hover:bg-white/10 transition-colors"
              onClick={handleLinkClick}
            >
              👤 Profile
            </Link>
            
            {/* Admin Tools Section */}
            {(user?.userType === 'provider' || user?.userType === 'admin' || user?.userType === 'supervisor') && (
              <>
                <div className="border-t border-white/20 my-2"></div>
                <div className="px-4 py-2 text-xs font-medium text-white/60 uppercase tracking-wider">
                  Admin Tools
                </div>
                {user?.userType === 'provider' && (
                  <Link 
                    to="/provider-dashboard" 
                    className="block px-4 py-2 text-white hover:bg-white/10 transition-colors"
                    onClick={handleLinkClick}
                  >
                    🏪 Provider Dashboard
                  </Link>
                )}
                {user?.userType === 'admin' && (
                  <Link 
                    to="/admin" 
                    className="block px-4 py-2 text-white hover:bg-white/10 transition-colors"
                    onClick={handleLinkClick}
                  >
                    ⚙️ Admin Panel
                  </Link>
                )}
                {user?.userType === 'admin' && (
                  <Link 
                    to="/supervisor-dashboard" 
                    className="block px-4 py-2 text-white hover:bg-white/10 transition-colors"
                    onClick={handleLinkClick}
                  >
                    👥 Supervisor View
                  </Link>
                )}
                {user?.userType === 'supervisor' && (
                  <Link 
                    to="/supervisor-dashboard" 
                    className="block px-4 py-2 text-white hover:bg-white/10 transition-colors"
                    onClick={handleLinkClick}
                  >
                    ⚙️ Supervisor Panel
                  </Link>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardNavDropdown;